import * as PopoverPrimitive from "@radix-ui/react-popover";

import {forwardRef} from "react";
import {cn} from "@/lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

/**
 * `PopoverAnchor` positions the popover next to an arbitrary element WITHOUT
 * installing the auto-toggle click/keyboard handlers that `PopoverTrigger`
 * bakes in. Use it when the trigger element needs its own click semantics —
 * e.g. the chip row in `UserMultiSelect` where clicking a chip's × must not
 * close the popover (Radix' built-in toggle would fight the controlled
 * `open` state and produce the "appears and disappears" flicker).
 */
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none animate-in data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
